export default __webpack_public_path__ + "static/d-feature-4-4f6e915152338bd12de2c63e11d2896b.png";